import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { initializeApp } from 'firebase/app';
import { Dialog } from 'antd-mobile';
import client, { IOS } from './client';

export const STORAGE_TOKEN_KEY = 'FCM_TOKEN_KEY';

export const firebaseConfig = {
  // Your web app's Firebase configuration here
  // See https://firebase.google.com/docs/web/setup#add-sdks-initialize
  apiKey: 'AIzaSyC04i_aEjoyRvC4uTEZ3gZSu84BKbqv6pY',
  authDomain: 'webapp-c875c.firebaseapp.com',
  projectId: 'webapp-c875c',
  storageBucket: 'webapp-c875c.appspot.com',
  messagingSenderId: '322835072074',
  appId: '1:322835072074:web:8c3d3017afd278a876d2b3',
  measurementId: 'G-LPSF837VYT'
};

export const vapidKey =
  'BHTrVkecbi1Ko0qtcSTozQJu50E5vxMi_0iF0RjLtqfbhBLSoKX3rD9VSMkTeLHV17AchYRSQ0e5xIiYPvuAjN4';

initializeApp(firebaseConfig);

let getFcmToken = (): any => {};
if (client.getOS() !== IOS && 'serviceWorker' in navigator) {
  try {
    const messaging = getMessaging();
    if (messaging) {
      onMessage(messaging, payload => {
        console.log('---- [main.ts] onMessage ----', payload);
        const token = localStorage.getItem(STORAGE_TOKEN_KEY) || '';
        if (token) {
          const params = new URLSearchParams();
          params.append('messageToken', token);
          params.append('messageId', payload.data!.messageId);
          fetch(
            `${import.meta.env.VITE_BASE_URL}message/pwaMessageConfirm?${params}`
          )
            .then(res => res.json())
            .then(res => {
              console.log('用户在程序内收到消息', params, res);
            });
        }

        Dialog.alert({
          title:
            payload.data!.title.length >= 5
              ? `${payload.data!.title.slice(0, 5)}...`
              : payload.data!.title,
          content: (
            <div style={{ wordBreak: 'break-all', textAlign: 'center' }}>
              {payload.data!.body}
            </div>
          )
        });
      });
      getFcmToken = () => {
        return getToken(messaging, { vapidKey })
          .then(currentToken => {
            console.log('【消息推送】 getToken ----->  ', currentToken);
            localStorage.setItem(STORAGE_TOKEN_KEY, currentToken);
            return currentToken || '';
          })
          .catch(err => {
            console.log('---- 【消息推送】 获取消息token失败 ----  ', err);
            localStorage.setItem(STORAGE_TOKEN_KEY, '');
            return '';
          });
      };
    }
  } catch (error) {
    console.error('Error initializing Firebase Messaging:', error);
  }
}

export { getFcmToken };
